/* Article only. Native disclosure; no app, dependencies or global scroll loop. */
(() => {
  function init(scope = document) {
    scope.querySelectorAll('[data-zb-article-toc]:not([data-ready])').forEach(toc => {
      toc.dataset.ready = 'true';
      const content = toc.closest('.article-template__content');
      if (!content) return;
      const headings = [...content.querySelectorAll('h2,h3')].filter(h => !toc.contains(h) && h.textContent.trim());
      if (headings.length < 2) return;
      const list = toc.querySelector('ul'), links = new Map();
      headings.forEach((heading, index) => {
        if (!heading.id) {
          const base = heading.textContent.trim().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9\s-]/g, '').trim().replace(/\s+/g, '-').replace(/-+/g, '-') || `sekcja-${index + 1}`;
          let id = 'toc-' + base, suffix = 1;
          while (document.getElementById(id)) id = `toc-${base}-${suffix++}`;
          heading.id = id;
        }
        const li = document.createElement('li'), a = document.createElement('a');
        li.dataset.level = heading.tagName.slice(1); a.href = '#' + encodeURIComponent(heading.id); a.textContent = heading.textContent.trim();
        li.append(a); list.append(li); links.set(heading, a);
      });
      toc.hidden = false;
      toc.addEventListener('click', event => {
        const a = event.target.closest('a[href^="#"]'); if (!a) return;
        const target = document.getElementById(decodeURIComponent(a.hash.slice(1))); if (!target) return;
        event.preventDefault();
        target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block:'start'});
        history.replaceState(null, '', a.hash);
        target.setAttribute('tabindex','-1'); target.focus({preventScroll:true});
      });
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(entries => {
          const current = entries.filter(e => e.isIntersecting).sort((a,b) => a.boundingClientRect.top - b.boundingClientRect.top)[0];
          if (!current) return;
          links.forEach(a => a.removeAttribute('aria-current')); links.get(current.target)?.setAttribute('aria-current','location');
        }, {rootMargin:'-100px 0px -55% 0px'});
        headings.forEach(h => observer.observe(h));
        document.addEventListener('shopify:section:unload', e => {if (e.target.contains(toc)) observer.disconnect();});
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), {once:true}); else init();
  document.addEventListener('shopify:section:load', e => init(e.target));
})();
